// https://vuex.vuejs.org/en/mutations.html

import { apiServer } from '../setup-axios'
import router from '../router';
import { logout_keycloak } from '../services/KeycloakService';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  SET_USER_DATA (state, user_response) {
    localStorage.setItem('user', JSON.stringify(user_response))
    localStorage.setItem('status', user_response.password_status)
    localStorage.setItem('accessTime', new Date())
    localStorage.setItem('token-type', "Internal")
    if (localStorage.getItem('currentPeran') === null) {
      localStorage.setItem('currentPeran', user_response.list_peran[0].kode_peran)
    }
    
    console.log('set token : ', user_response)
    // implement for keycloak: access token, refresh token.
    apiServer.defaults.headers.common.Authorization = `Bearer ${
      user_response.token
    }`
    apiServer.defaults.headers.common['X-Token-Type'] = 'Internal'
  },
  
  LOGOUT (state) {
    apiServer.post('/logout')
    console.log('logout')
    console.log(state.snackbar.snackbarText)
    if (localStorage.getItem('token-type') === "Keycloak") {
      localStorage.clear()
      localStorage.setItem('snackbarText', 'Logout Berhasil')
      logout_keycloak()
    } else {
      localStorage.clear()
      router.push('/')
    }
  },
  SET_SNACKBAR (state, payload) {
    state.snackbar.snackbarColor = payload.snackbarColor
    state.snackbar.snackbarText = payload.snackbarText
  },
  RESET_LOGOUT_TIMER () {
    localStorage.setItem('accessTime', new Date())
  },
  SET_ANGGOTA (state, payload) {
    state.anggota.id = payload.id
    state.anggota.nama = payload.nama
    state.anggota.angkaFavorit = payload.angkaFavorit
    state.anggota.tanggalLahir = payload.tanggalLahir
  },
  SET_DESKRIPSI_KENDARAAN (state, payload) {
    state.deskripsiKendaraan.cariKendaraaanByNomorRangkaDialog = payload.cariKendaraaanByNomorRangkaDialog
    state.deskripsiKendaraan.cariKodeJenisDialog = payload.cariKodeJenisDialog
    state.deskripsiKendaraan.merk = payload.merk
    state.deskripsiKendaraan.tipe = payload.tipe
    state.deskripsiKendaraan.jenis = payload.jenis
    state.deskripsiKendaraan.tahunBuat = payload.tahunBuat
    state.deskripsiKendaraan.bahanBakar = payload.bahanBakar
    state.deskripsiKendaraan.kelompok = payload.kelompok
    state.deskripsiKendaraan.kategori = payload.kategori
    state.deskripsiKendaraan.kodeJenis = payload.kodeJenis
    state.deskripsiKendaraan.kodeMerekTipe = payload.kodeMerekTipe
    state.deskripsiKendaraan.kodeBahanBakar = payload.kodeBahanBakar
    state.deskripsiKendaraan.idTipeKendaraan = payload.idTipeKendaraan
    state.deskripsiKendaraan.status = payload.status
    state.deskripsiKendaraan.tahunNilaiJual = payload.tahunNilaiJual
  },
  SET_KENDARAAN (state, payload) {
    state.kendaraan.nomorPolisi = payload.nomorPolisi
    state.kendaraan.kodeJenisKendaran = payload.kodeJenisKendaran
    state.kendaraan.nomorRangka = payload.nomorRangka
    state.kendaraan.nomorMesin = payload.nomorMesin
    state.kendaraan.cc = payload.cc
    state.kendaraan.warnaKendaraan = payload.warnaKendaraan
    state.kendaraan.warnaPlat = payload.warnaPlat
    state.kendaraan.fungsiKendaraan = payload.fungsiKendaraan
    state.kendaraan.posisiSetir = payload.posisiSetir
    state.kendaraan.jumlahPintu = payload.jumlahPintu
    state.kendaraan.radio = payload.radio
    state.kendaraan.hp = payload.hp
    state.kendaraan.keterangan = payload.keterangan
    state.kendaraan.noBpkb = payload.noBpkb
    state.kendaraan.noStnk = payload.noStnk
    state.kendaraan.noBlankoStnk = payload.noBlankoStnk
    state.kendaraan.jumlahSumbu = payload.jumlahSumbu
    state.kendaraan.jumlahRoda = payload.jumlahRoda
    state.kendaraan.jumlahGandengan = payload.jumlahGandengan
    state.kendaraan.masaPajak = payload.masaPajak
    state.kendaraan.masaStnk = payload.masaStnk
    state.kendaraan.sumber = payload.sumber
    state.kendaraan.idRiwayatRanmor = payload.idRiwayatRanmor
  },
  SET_SYARAT (state, payload) {
    state.syarat.jenisTransaksi = payload.jenisTransaksi
    state.syarat.nomorIdentitasKuasa = payload.nomorIdentitasKuasa
    state.syarat.namaKuasa = payload.namaKuasa
  },
  SET_JENIS_TRANSAKSI (state, payload) {
    state.jenisTransaksi.jenisTransaksi = payload.jenisTransaksi
    state.jenisTransaksi.flowTransaksi = payload.flowTransaksi
  },
  APPEND_DOKUMEN_SYARAT (state, payload) {
    state.dokumenSyarat.push(payload)
  },
  RESET_DOKUMEN_SYARAT (state, payload) {
    state.dokumenSyarat = []
  },
  RESET_KENDARAAN (state, payload) {
    state.kendaraan.nomorPolisi = null
    state.kendaraan.nomorRangka = null
    state.kendaraan.nomorMesin = null
    state.kendaraan.cc = null
    state.kendaraan.warnaKendaraan = null
    state.kendaraan.warnaPlat = null
    state.kendaraan.fungsiKendaraan = null
    state.kendaraan.posisiSetir = null
    state.kendaraan.jumlahPintu = null
    state.kendaraan.radio = null
    state.kendaraan.hp = null
    state.kendaraan.keterangan = null
    state.kendaraan.noBpkb = null
    state.kendaraan.noStnk = null
    state.kendaraan.noBlankoStnk = null
    state.kendaraan.jumlahSumbu = null
    state.kendaraan.jumlahGandengan = null
    state.kendaraan.jumlahRoda = null
    state.kendaraan.njkb = null
    state.kendaraan.masaPajak = null
    state.kendaraan.masaStnk = null
    state.kendaraan.sumber = null
    state.kendaraan.idRiwayatRanmor = null
  },
  RESET_WAJIB_PAJAK (state, payload) {
    state.wajibPajak.jenisIdentitas = null
    state.wajibPajak.nomorIdentitas = null
    state.wajibPajak.nomorKK = null
    state.wajibPajak.nama = null
    state.wajibPajak.tanggalLahir = null
    state.wajibPajak.alamat = null
    state.wajibPajak.propinsi = null
    state.wajibPajak.kotamadya = null
    state.wajibPajak.kecamatan = null
    state.wajibPajak.kelurahan = null
    state.wajibPajak.kodePos = null
    state.wajibPajak.kodeBadanHukum = null
    state.wajibPajak.email = null
    state.wajibPajak.noTelepon = null
    state.wajibPajak.rt = null
    state.wajibPajak.rw = null
    state.wajibPajak.kendaraanKe = null
  },
  SET_WAJIB_PAJAK (state, payload) {
    state.wajibPajak.jenisIdentitas = payload.jenisIdentitas
    state.wajibPajak.nomorIdentitas = payload.nomorIdentitas
    state.wajibPajak.nomorKK = payload.nomorKK
    state.wajibPajak.nama = payload.nama
    state.wajibPajak.tanggalLahir = payload.tanggalLahir
    state.wajibPajak.alamat = payload.alamat
    state.wajibPajak.propinsi = payload.propinsi
    state.wajibPajak.kotamadya = payload.kotamadya
    state.wajibPajak.kecamatan = payload.kecamatan
    state.wajibPajak.kelurahan = payload.kelurahan
    state.wajibPajak.kodePos = payload.kodePos
    state.wajibPajak.kodeBadanHukum = payload.kodeBadanHukum
    state.wajibPajak.email = payload.email
    state.wajibPajak.noTelepon = payload.noTelepon
    state.wajibPajak.rt = payload.rt
    state.wajibPajak.rw = payload.rw

  },
  SET_ERROR_LOGIN (state, payload) {
    state.errorLogin.pesan = payload
  },
  SET_IDENTITAS (state, payload) {
    state.identitas.cariIdentitasDialog = payload.cariIdentitasDialog
  },
  RESET_DESKRIPSI_KENDARAAN (state, payload) {
    state.deskripsiKendaraan.merk = null
    state.deskripsiKendaraan.tipe = null
    state.deskripsiKendaraan.tahunBuat = null
    state.deskripsiKendaraan.bahanBakar = null
    state.deskripsiKendaraan.kelompok = null
    state.deskripsiKendaraan.kategori = null
    state.deskripsiKendaraan.kodeJenis = null
    state.deskripsiKendaraan.kodeMerekTipe = null
    state.deskripsiKendaraan.kodeBahanBakar = null
    state.deskripsiKendaraan.idTipeKendaraan = null
    state.deskripsiKendaraan.jenis = null
    state.deskripsiKendaraan.status = null
    state.deskripsiKendaraan.tahunNilaiJual = null
  },
  SET_TUJUAN_MUTASI(state, payload)  {
    state.tujuanMutasi.idTujuanMutasi = payload.idTujuanMutasi
    state.tujuanMutasi.namaTujuanMutasi = payload.namaTujuanMutasi
    state.tujuanMutasi.alamatTujuanMutasi =  payload.alamatTujuanMutasi
  },
  RESET_TUJUAN_MUTASI(state, payload)  {
    state.tujuanMutasi.idTujuanMutasi = null
    state.tujuanMutasi.namaTujuanMutasi = null
    state.tujuanMutasi.alamatTujuanMutasi =  null
  },
  SET_KENDARAAN_CARI_KENDARAAN (state, payload) {
    state.kendaraan.nomorPolisi = payload.nomorPolisi
    state.kendaraan.kodeJenisKendaran = payload.kodeJenisKendaran
    state.kendaraan.nomorRangka = payload.nomorRangka
    state.kendaraan.nomorMesin = payload.nomorMesin
    state.kendaraan.cc = payload.cc
    state.kendaraan.warnaKendaraan = payload.warnaKendaraan
    state.kendaraan.warnaPlat = payload.warnaPlat
    state.kendaraan.fungsiKendaraan = payload.fungsiKendaraan
    state.kendaraan.posisiSetir = payload.posisiSetir
    state.kendaraan.jumlahPintu = payload.jumlahPintu
    state.kendaraan.radio = payload.radio
    state.kendaraan.hp = payload.hp
    state.kendaraan.keterangan = payload.keterangan
    state.kendaraan.noBpkb = payload.noBpkb
    state.kendaraan.noStnk = payload.noStnk
    state.kendaraan.noBlankoStnk = payload.noBlankoStnk
    state.kendaraan.jumlahSumbu = payload.jumlahSumbu
    state.kendaraan.jumlahRoda = payload.jumlahRoda
    state.kendaraan.jumlahGandengan = payload.jumlahGandengan
    state.kendaraan.sumber = payload.sumber
    state.kendaraan.idRiwayatRanmor = payload.idRiwayatRanmor
  },
}
